export const supportUrls = {
  // TI Billings
  refundPolicy:
    'https://support.trulyinbox.com/en/articles/8516555-refund-policy',
  pricingFAQ:
    'https://support.trulyinbox.com/en/articles/9734155-trulyinbox-new-pricing',

  teamsOfService: 'https://www.saleshandy.com/terms/',
  scheduleCall:
    'https://www.saleshandy.com/demo/?utm_source=webapp&utm_medium=top_right_button&utm_campaign=product_demo_v3/',
  becomeOurAffiliate:
    'https://www.saleshandy.com/affiliate-program/?utm_source=inapp&utm_medium=direct&utm_campaign=affiliate',
  warmupFaq:
    'https://support.saleshandy.com/article/330-how-does-saleshandy-email-warm-up-work',
  outreachPlanViewFAQ:
    ' https://support.saleshandy.com/article/339-which-plans-are-available-in-saleshandy',
  updateCardDetails:
    'https://billing.stripe.com/p/login/14kbJC7H05AW8qk9AA?prefilled_email=',
  smtpImapFaq:
    'https://support.saleshandy.com/article/322-unable-to-connect-email-account-with-smtp-and-imap',
  smtpImapCouldNotAuth:
    'https://support.trulyinbox.com/en/articles/8516558-how-to-fix-smtp-imap-could-not-authenticate-error',
  smtpImapEmailNotFound:
    'https://support.trulyinbox.com/en/articles/8516581-how-to-fix-smtp-imap-email-not-found-error',
  smtpImapConnectionTimeOut:
    'https://support.trulyinbox.com/en/articles/8516584-how-to-fix-smtp-imap-connection-timeout-error',
  smtpImapOtherError:
    'https://support.trulyinbox.com/en/articles/8516585-how-to-fix-smtp-imap-other-error',
  pauseProspectInSequence:
    'https://support.saleshandy.com/article/344-how-to-pause-a-prospect-in-sequence?preview=63aad6391e9b0d75c7275db4',
  spintaxBlog:
    'https://support.saleshandy.com/article/345-what-is-spintax-and-how-to-use-it',
  coldEmailMasterClass:
    'https://www.saleshandy.com/cold-email-masterclass/?utm_source=inapp&utm_medium=inappsection&utm_campaign=coldemailmastery',
  intercomBaseUrl: 'https://api-iam.intercom.io',
  howToConnectGmailAccountWithSmtpImap:
    'https://support.trulyinbox.com/en/articles/12928503-how-to-connect-an-email-account-using-smtp-in-trulyinbox',
  howToConnectGmailAccountWithSmtpImapStep3:
    'https://support.trulyinbox.com/en/articles/8516510-how-to-connect-a-gmail-account-with-smtp-imap-in-trulyinbox',
  howToConnectGmailAccountWithSmtpImapVideo: 'https://youtu.be/fUpKGwuncvQ',
  privacyPolicy:
    'https://support.trulyinbox.com/en/articles/8707865-privacy-policy-trulyinbox',
  termsOfServices:
    'https://support.trulyinbox.com/en/articles/8516536-terms-of-sevice-trulyinbox',
  sendColdEmail:
    'https://my.saleshandy.com/signup?utm_source=trulyinbox_app&utm_medium=inappTI&utm_campaign=trulyinbox_partner',
  connectBulkEmailDemoCSV:
    'https://v3artifacts.s3.us-west-2.amazonaws.com/Connect_Bulk_Email_TrulyInbox.csv',
  bulkImportCSVGuide:
    'https://support.trulyinbox.com/en/articles/12928504-connect-multiple-email-accounts-using-smtp-bulk-setup',
  goauthStepsToConnectVideoURL:
    'https://fast.wistia.net/embed/iframe/aoqxqjwkiv?web_component=true&seo=true',

  emailAccountSpf:
    'https://support.trulyinbox.com/en/articles/12928512-what-is-an-spf-record',
  dkimBlog:
    'https://support.trulyinbox.com/en/articles/12752702-dkim-what-why-and-how-to-set-it-up',
  emailAccountCustomDomain:
    'https://support.trulyinbox.com/en/articles/8925636-what-is-custom-domain-setup-in-trulyinbox',
  emailAccountDmarc:
    'https://support.trulyinbox.com/en/articles/9335209-dmarc-what-why-and-how-to-set-it-up',
  domainAndIPBlacklistBlog:
    'https://support.trulyinbox.com/en/articles/12928544-what-domain-and-ip-blacklists-are-and-how-to-remove-them',
  mxRecordBlog:
    'https://support.trulyinbox.com/en/articles/12928533-how-to-set-up-mx-records-for-your-domain',
  emailAgeBlog:
    'https://support.trulyinbox.com/en/articles/8925644-what-is-email-age-setup-in-trulyinbox',
  emailSendingIntervalBlog:
    'https://support.trulyinbox.com/en/articles/8925646-what-is-email-sending-interval-setup-in-trulyinbox',
  dailySendingQuotaBlog:
    'https://support.trulyinbox.com/en/articles/8925648-what-is-daily-sending-quota-setup-in-trulyinbox',
  spfBlog:
    'https://support.trulyinbox.com/en/articles/12928512-what-is-an-spf-record',
  domainIPBlacklistVideoUrl:
    'https://support.trulyinbox.com/en/articles/12752798-how-to-delist-ip-and-domain-from-blacklist',
  dmarcBlog:
    'https://support.trulyinbox.com/en/articles/9335209-dmarc-what-why-and-how-to-set-it-up',

  spfVideoUrl:
    'https://fast.wistia.net/embed/iframe/aoqxqjwkiv?web_component=true&seo=true',
  MXRecordBlog:
    'https://support.trulyinbox.com/en/articles/12928533-how-to-set-up-mx-records-for-your-domain',
  rewardTerms:
    'https://support.trulyinbox.com/en/articles/12928494-trulyinbox-review-rewards-program',
  contentSettingsStrategy:
    'https://support.trulyinbox.com/en/articles/12928517-understanding-warm-up-strategies-in-trulyinbox',
  contentSettingsSendingSchedule:
    'https://support.trulyinbox.com/en/articles/12928518-email-sending-schedule-in-warm-up',
  contentSettingsRecipientsEspPrioritization:
    'https://support.trulyinbox.com/en/articles/12928519-esp-specific-warmup-targeting',
  howToConnectGmailWorkspace:
    'https://support.trulyinbox.com/en/articles/12928554-how-to-connect-google-workspace-mailboxes-in-bulk',
  howToConnectGmailOAuth:
    'https://support.trulyinbox.com/en/articles/12928552-how-to-connect-a-google-workspace-mailbox-oauth',
  howToConnectGmailAppPassword:
    'https://support.trulyinbox.com/en/articles/12928553-how-to-connect-a-gmail-account-app-password',
  howToConnectMicrosoftOAuth:
    'https://support.trulyinbox.com/en/articles/12928555-how-to-connect-a-microsoft-mailbox-oauth',
  howToConnectMicrosoftBulk:
    'https://support.trulyinbox.com/en/articles/12928556-how-to-connect-microsoft-o365-mailboxes-in-bulk',
  howToConnectCsvBulkImport:
    'https://support.trulyinbox.com/en/articles/12928557-how-to-connect-multiple-mailboxes-with-a-csv-bulk-import',
  howToConnectZoho:
    'https://support.trulyinbox.com/en/articles/12928564-how-to-connect-a-zoho-mailbox-smtpimap',
  howToConnectSendgrid:
    'https://support.trulyinbox.com/en/articles/12928560-how-to-connect-sendgrid-to-trulyinbox',
  howToConnectAmazonSes:
    'https://support.trulyinbox.com/en/articles/12928559-how-to-connect-amazon-ses-to-trulyinbox',
  howToConnectMailgun:
    'https://support.trulyinbox.com/en/articles/12928561-how-to-connect-mailgun-to-trulyinbox',
  howToConnectElasticEmail:
    'https://support.trulyinbox.com/en/articles/12928562-how-to-connect-elastic-email-to-trulyinbox',
  howToConnectYandex:
    'https://support.trulyinbox.com/en/articles/12928565-how-to-connect-a-yandex-mailbox-smtpimap',
  howToConnectYahoo:
    'https://support.trulyinbox.com/en/articles/12928566-how-to-connect-a-yahoo-mailbox-app-password',
  howToConnectGoDaddy:
    'https://support.trulyinbox.com/en/articles/12928563-how-to-connect-a-godaddy-mailbox-smtpimap',
  howToConnectOtherProvider:
    'https://support.trulyinbox.com/en/articles/12928567-how-to-connect-any-mailbox-with-custom-smtpimap-other-provider',
};
